import { http, HttpResponse } from 'msw'
import { StatusCodes } from 'http-status-codes'

import { api } from 'app/utils/constants'

import { Product } from 'app/types/catalogue/product'

export const modify = http.post(
    `${process.env.REACT_APP_API_ADDRESS}/${api.catalogue.products.import.MODIFY}`,
    async ({ request }) => {
        const payload = await request.json()

        // Wrong data
        if (!payload) {
            return HttpResponse.json(undefined, {
                status: StatusCodes.UNPROCESSABLE_ENTITY,
            })
        }

        return HttpResponse.json<Product[]>([], {
            status: StatusCodes.OK,
        })
    },
)
